var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseMultiselect,{attrs:{"value":_setup.selectedId,"options":_setup.listas,"value-key":"id","label-key":"nombre","placeholder":_vm.placeholder || _vm.$t('bases.seleccionar_temporada'),"multiple":_vm.multiple},on:{"input":_setup.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }